module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Foreword by Ed Stetzer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("PART ONE: Eyes to See")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("1")]), _vm._v(" The First Urban Century")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("2")]), _vm._v(" Cities: Headache or Opportunity?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("3")]), _vm._v(" What God Thinks of Cities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: Eight Critical Responses")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("4")]), _vm._v(" Action 1: Pray Together")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("5")]), _vm._v(" Action 2: Exegete the City")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("6")]), _vm._v(" Action 3: Push Against Urban Poverty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("7")]), _vm._v(" Action 4: Reach Out to Diasporas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("8")]), _vm._v(" Action 5: Form Healthy Churches")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("9")]), _vm._v(" Action 6: Confront Sinful Structures")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("10")]), _vm._v(" Action 7: Address Real Human Pain Directly")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("11")]), _vm._v(" Action 8: Embrace a Wider Vision")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen SOM_appen1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Greater Things Are Still to Come")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Featured Ministries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Serving God in Today’s Cities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0